export default "__VITE_ASSET__60b3753e__"